[
  {
    "id": "cafe-matin",
    "name": "Café du Matin",
    "icon": "☕",
    "description": "Ambiance douce pour bien démarrer la journée",
    "trackIds": [1, 5, 3, 7, 11],
    "color": "#D4956A",
    "bpmRange": [70, 95],
    "cover": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["jazz-swing", "lounge", "chill"],
    "businessTypes": ["restaurant", "office"],
    "moods": ["jazz", "chill", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "cafe-brunch",
    "name": "Brunch Vibes",
    "icon": "🥐",
    "description": "Détente et bonne humeur pour un brunch réussi",
    "trackIds": [3, 1, 5, 6, 11],
    "color": "#F4A261",
    "bpmRange": [85, 110],
    "cover": "https://images.unsplash.com/photo-1533089860892-a7c6f0a88666?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["bossa-nova", "indie", "chill"],
    "businessTypes": ["restaurant", "salon"],
    "moods": ["chill", "acoustic", "pop"],
    "_curationStatus": "draft"
  },
  {
    "id": "cafe-cosy",
    "name": "Cosy Corner",
    "icon": "🕯️",
    "description": "Chaleureux et feutré pour un café douillet",
    "trackIds": [5, 4, 1, 7, 2],
    "color": "#8B5E3C",
    "bpmRange": [60, 85],
    "cover": "https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["chill", "ambient", "lounge"],
    "businessTypes": ["restaurant", "hotel"],
    "moods": ["chill", "ambient", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "cafe-coworking",
    "name": "Focus Flow",
    "icon": "💻",
    "description": "Concentration et productivité pour coworkers",
    "trackIds": [5, 11, 4, 1, 6],
    "color": "#4A7C94",
    "bpmRange": [75, 100],
    "cover": "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["chill", "indie", "ambient"],
    "businessTypes": ["office"],
    "moods": ["chill", "acoustic", "ambient"],
    "_curationStatus": "draft"
  },
  {
    "id": "resto-bistro",
    "name": "Bistro Parisien",
    "icon": "🥖",
    "description": "L'âme d'un bistro authentique et convivial",
    "trackIds": [1, 3, 7, 2, 5],
    "color": "#C0392B",
    "bpmRange": [80, 105],
    "cover": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["jazz-swing", "bossa-nova", "lounge"],
    "businessTypes": ["restaurant"],
    "moods": ["jazz", "lounge", "chill"],
    "_curationStatus": "draft"
  },
  {
    "id": "resto-gastro",
    "name": "Table Gastronomique",
    "icon": "🍽️",
    "description": "Élégance et raffinement pour grande table",
    "trackIds": [2, 7, 4, 5, 1],
    "color": "#2C3E50",
    "bpmRange": [55, 80],
    "cover": "https://images.unsplash.com/photo-1559339352-11d035aa65de?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["lounge", "ambient", "jazz-swing"],
    "businessTypes": ["restaurant", "hotel"],
    "moods": ["lounge", "classical", "ambient"],
    "_curationStatus": "draft"
  },
  {
    "id": "resto-aperitif",
    "name": "L'Heure de l'Apéro",
    "icon": "🥂",
    "description": "Apéritif festif et décontracté",
    "trackIds": [9, 3, 6, 5, 10],
    "color": "#F39C12",
    "bpmRange": [95, 120],
    "cover": "https://images.unsplash.com/photo-1547595628-c61a29f496f0?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["deep-house", "bossa-nova", "indie"],
    "businessTypes": ["restaurant", "bar"],
    "moods": ["energetic", "pop", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "resto-sunday-vibes",
    "name": "Sunday Vibes",
    "icon": "🌿",
    "description": "Dimanche en douceur, brunch relaxant",
    "trackIds": [3, 5, 11, 1, 4],
    "color": "#27AE60",
    "bpmRange": [70, 95],
    "cover": "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["bossa-nova", "chill", "indie"],
    "businessTypes": ["restaurant"],
    "moods": ["chill", "acoustic", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "bar-happy-hour",
    "name": "Happy Hour",
    "icon": "🍻",
    "description": "Ambiance pré-soirée, énergie montante",
    "trackIds": [9, 10, 6, 8, 3],
    "color": "#E74C3C",
    "bpmRange": [100, 125],
    "cover": "https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["deep-house", "rnb", "indie"],
    "businessTypes": ["bar", "restaurant"],
    "moods": ["energetic", "pop", "electronic"],
    "_curationStatus": "draft"
  },
  {
    "id": "bar-rooftop",
    "name": "Rooftop Sunset",
    "icon": "🌅",
    "description": "Coucher de soleil sur les toits de la ville",
    "trackIds": [10, 9, 5, 6, 11],
    "color": "#E67E22",
    "bpmRange": [95, 115],
    "cover": "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["rnb", "deep-house", "chill"],
    "businessTypes": ["bar", "hotel"],
    "moods": ["energetic", "lounge", "pop"],
    "_curationStatus": "draft"
  },
  {
    "id": "bar-jazz-club",
    "name": "Jazz Club",
    "icon": "🎷",
    "description": "L'authenticité d'un vrai club de jazz",
    "trackIds": [1, 7, 2, 3, 5],
    "color": "#1A1A2E",
    "bpmRange": [75, 105],
    "cover": "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["jazz-swing", "lounge", "bossa-nova"],
    "businessTypes": ["bar", "restaurant", "hotel"],
    "moods": ["jazz", "lounge", "classical"],
    "_curationStatus": "draft"
  },
  {
    "id": "salon-detente",
    "name": "Détente Absolue",
    "icon": "✂️",
    "description": "Relaxation douce pour coiffeurs et beauty",
    "trackIds": [4, 5, 7, 1, 11],
    "color": "#A29BFE",
    "bpmRange": [60, 85],
    "cover": "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "chill", "lounge"],
    "businessTypes": ["salon", "spa"],
    "moods": ["chill", "ambient", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "salon-modern",
    "name": "Urban Style",
    "icon": "💇",
    "description": "Tendance et urban pour salon moderne",
    "trackIds": [6, 10, 11, 9, 5],
    "color": "#6C5CE7",
    "bpmRange": [90, 115],
    "cover": "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["indie", "rnb", "chill"],
    "businessTypes": ["salon", "boutique"],
    "moods": ["pop", "acoustic", "energetic"],
    "_curationStatus": "draft"
  },
  {
    "id": "salon-luxe",
    "name": "Salon Prestige",
    "icon": "💎",
    "description": "Élégance premium pour instituts haut de gamme",
    "trackIds": [7, 2, 4, 5, 1],
    "color": "#B8860B",
    "bpmRange": [55, 80],
    "cover": "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["lounge", "ambient", "jazz-swing"],
    "businessTypes": ["salon", "hotel", "spa"],
    "moods": ["lounge", "classical", "chill"],
    "_curationStatus": "draft"
  },
  {
    "id": "salon-energique",
    "name": "Energie Positive",
    "icon": "⚡",
    "description": "Motivation et bonne humeur pour salon dynamique",
    "trackIds": [8, 6, 10, 9, 11],
    "color": "#FD79A8",
    "bpmRange": [105, 130],
    "cover": "https://images.unsplash.com/photo-1522337660859-02fbefca4702?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["edm", "indie", "rnb"],
    "businessTypes": ["salon", "gym"],
    "moods": ["energetic", "pop", "electronic"],
    "_curationStatus": "draft"
  },
  {
    "id": "boutique-pop-fashion",
    "name": "Fashion Week",
    "icon": "👗",
    "description": "Tendance et chic pour boutique mode",
    "trackIds": [6, 11, 10, 9, 5],
    "color": "#E84393",
    "bpmRange": [95, 120],
    "cover": "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["indie", "rnb", "chill"],
    "businessTypes": ["boutique", "salon"],
    "moods": ["pop", "energetic", "acoustic"],
    "_curationStatus": "draft"
  },
  {
    "id": "boutique-concept-store",
    "name": "Concept Store",
    "icon": "🛍️",
    "description": "Curated et lifestyle pour concept store",
    "trackIds": [11, 6, 5, 3, 10],
    "color": "#2D3436",
    "bpmRange": [88, 112],
    "cover": "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["indie", "chill", "bossa-nova"],
    "businessTypes": ["boutique"],
    "moods": ["acoustic", "chill", "pop"],
    "_curationStatus": "draft"
  },
  {
    "id": "boutique-mode-douce",
    "name": "Mode Douce",
    "icon": "🌸",
    "description": "Douceur et bienveillance pour boutique lifestyle",
    "trackIds": [5, 11, 3, 1, 6],
    "color": "#DDA0DD",
    "bpmRange": [75, 100],
    "cover": "https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["chill", "indie", "bossa-nova"],
    "businessTypes": ["boutique", "salon"],
    "moods": ["chill", "acoustic", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "spa-meditation",
    "name": "Méditation Profonde",
    "icon": "🧘",
    "description": "Plénitude et sérénité pour séances de méditation",
    "trackIds": [4, 5, 7, 11, 2],
    "color": "#00B894",
    "bpmRange": [45, 70],
    "cover": "https://images.unsplash.com/photo-1545389336-cf090694435e?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "chill", "lounge"],
    "businessTypes": ["spa", "hotel"],
    "moods": ["ambient", "chill", "classical"],
    "_curationStatus": "draft"
  },
  {
    "id": "spa-massage",
    "name": "Massage & Détente",
    "icon": "💆",
    "description": "Relaxation totale pour massages et soins",
    "trackIds": [4, 2, 5, 7, 1],
    "color": "#0984E3",
    "bpmRange": [55, 80],
    "cover": "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "lounge", "chill"],
    "businessTypes": ["spa", "salon"],
    "moods": ["ambient", "chill", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "spa-yoga-flow",
    "name": "Yoga Flow",
    "icon": "🌊",
    "description": "Fluidité et équilibre pour pratique yoga",
    "trackIds": [4, 5, 3, 11, 7],
    "color": "#74B9FF",
    "bpmRange": [65, 90],
    "cover": "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "bossa-nova", "chill"],
    "businessTypes": ["spa", "gym"],
    "moods": ["ambient", "chill", "acoustic"],
    "_curationStatus": "draft"
  },
  {
    "id": "spa-sauna",
    "name": "Sauna Nordique",
    "icon": "🌲",
    "description": "Chaleur et silence pour espace sauna",
    "trackIds": [4, 7, 5, 2, 1],
    "color": "#A0522D",
    "bpmRange": [50, 75],
    "cover": "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "lounge", "chill"],
    "businessTypes": ["spa", "hotel"],
    "moods": ["ambient", "classical", "chill"],
    "_curationStatus": "draft"
  },
  {
    "id": "gym-cardio",
    "name": "Cardio Blast",
    "icon": "🏃",
    "description": "Haute intensité pour entraînement cardio",
    "trackIds": [8, 9, 10, 6, 11],
    "color": "#E17055",
    "bpmRange": [120, 135],
    "cover": "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["edm", "deep-house", "rnb"],
    "businessTypes": ["gym"],
    "moods": ["energetic", "electronic", "pop"],
    "_curationStatus": "draft"
  },
  {
    "id": "gym-musculation",
    "name": "Power Training",
    "icon": "💪",
    "description": "Force et endurance pour musculation intense",
    "trackIds": [8, 10, 9, 6, 11],
    "color": "#D63031",
    "bpmRange": [115, 135],
    "cover": "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["edm", "rnb", "deep-house"],
    "businessTypes": ["gym"],
    "moods": ["energetic", "electronic", "pop"],
    "_curationStatus": "draft"
  },
  {
    "id": "gym-yoga-doux",
    "name": "Yoga Doux",
    "icon": "🕊️",
    "description": "Respiration et souplesse pour yoga restaurateur",
    "trackIds": [4, 5, 11, 3, 7],
    "color": "#55EFC4",
    "bpmRange": [60, 85],
    "cover": "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "chill", "bossa-nova"],
    "businessTypes": ["gym", "spa"],
    "moods": ["chill", "ambient", "acoustic"],
    "_curationStatus": "draft"
  },
  {
    "id": "hotel-lobby-elegant",
    "name": "Grand Lobby",
    "icon": "🏨",
    "description": "Accueil chaleureux et sophistiqué de grand hôtel",
    "trackIds": [7, 2, 1, 5, 4],
    "color": "#636E72",
    "bpmRange": [65, 90],
    "cover": "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["lounge", "jazz-swing", "ambient"],
    "businessTypes": ["hotel", "restaurant"],
    "moods": ["lounge", "classical", "chill"],
    "_curationStatus": "draft"
  },
  {
    "id": "hotel-rooftop-pool",
    "name": "Rooftop Pool",
    "icon": "🏊",
    "description": "Détente luxueuse au bord de la piscine",
    "trackIds": [3, 10, 9, 5, 6],
    "color": "#00CEC9",
    "bpmRange": [90, 115],
    "cover": "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["bossa-nova", "rnb", "deep-house"],
    "businessTypes": ["hotel", "spa"],
    "moods": ["lounge", "energetic", "chill"],
    "_curationStatus": "draft"
  },
  {
    "id": "hotel-spa-wellness",
    "name": "Wellness Retreat",
    "icon": "🌺",
    "description": "Bien-être total dans un cadre luxueux",
    "trackIds": [4, 7, 5, 2, 11],
    "color": "#6A0572",
    "bpmRange": [55, 80],
    "cover": "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["ambient", "lounge", "chill"],
    "businessTypes": ["hotel", "spa"],
    "moods": ["ambient", "classical", "lounge"],
    "_curationStatus": "draft"
  },
  {
    "id": "office-focus",
    "name": "Deep Focus",
    "icon": "🎯",
    "description": "Concentration maximale pour travail intense",
    "trackIds": [5, 4, 11, 1, 7],
    "color": "#353B48",
    "bpmRange": [70, 95],
    "cover": "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["chill", "ambient", "lounge"],
    "businessTypes": ["office"],
    "moods": ["chill", "ambient", "acoustic"],
    "_curationStatus": "draft"
  },
  {
    "id": "office-creativity",
    "name": "Creativity Boost",
    "icon": "🎨",
    "description": "Inspiration et créativité pour projets créatifs",
    "trackIds": [11, 6, 3, 5, 10],
    "color": "#F9CA24",
    "bpmRange": [85, 108],
    "cover": "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=400&h=400&fit=crop",
    "isDefault": true,
    "genres": ["indie", "bossa-nova", "chill"],
    "businessTypes": ["office"],
    "moods": ["acoustic", "pop", "chill"],
    "_curationStatus": "draft"
  }
]
